'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _construct = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var Cache = require('./cache');
var Common = require('./common');
var Compile = require('./compile');
var Errors = require('./errors');
var Extend = require('./extend');
var Manifest = require('./manifest');
var Ref = require('./ref');
var Template = require('./template');
var Trace = require('./trace');
var Schemas;
var internals = {
  types: {
    alternatives: require('./types/alternatives'),
    any: require('./types/any'),
    array: require('./types/array'),
    boolean: require('./types/boolean'),
    date: require('./types/date'),
    function: require('./types/function'),
    link: require('./types/link'),
    number: require('./types/number'),
    object: require('./types/object'),
    string: require('./types/string'),
    symbol: require('./types/symbol')
  },
  aliases: {
    alt: 'alternatives',
    bool: 'boolean',
    func: 'function'
  }
};
if (Buffer) {
  // $lab:coverage:ignore$
  internals.types.binary = require('./types/binary');
}
internals.root = function () {
  var root = {
    _types: new Set(Object.keys(internals.types))
  };

  // Types
  var _iterator = _createForOfIteratorHelper(root._types),
    _step;
  try {
    var _loop2 = function _loop2() {
      var type = _step.value;
      root[type] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        Assert(!args.length || ['alternatives', 'link', 'object'].includes(type), 'The', type, 'type does not allow arguments');
        return internals.generate(this, internals.types[type], args);
      };
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop2();
    }

    // Shortcuts
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _loop = function _loop() {
    var method = _arr[_i];
    root[method] = function () {
      var _this$any;
      return (_this$any = this.any())[method].apply(_this$any, arguments);
    };
  };
  for (var _i = 0, _arr = ['allow', 'custom', 'disallow', 'equal', 'exist', 'forbidden', 'invalid', 'not', 'only', 'optional', 'options', 'prefs', 'preferences', 'required', 'strip', 'valid', 'when']; _i < _arr.length; _i++) {
    _loop();
  }

  // Methods

  Object.assign(root, internals.methods);

  // Aliases

  for (var alias in internals.aliases) {
    var target = internals.aliases[alias];
    root[alias] = root[target];
  }
  root.x = root.expression;

  // Trace

  if (Trace.setup) {
    // $lab:coverage:ignore$
    Trace.setup(root);
  }
  return root;
};
internals.methods = {
  ValidationError: Errors.ValidationError,
  version: Common.version,
  cache: Cache.provider,
  assert: function assert(value, schema) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }
    internals.assert(value, schema, true, args);
  },
  attempt: function attempt(value, schema) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }
    return internals.assert(value, schema, false, args);
  },
  build: function build(desc) {
    Assert(typeof Manifest.build === 'function', 'Manifest functionality disabled');
    return Manifest.build(this, desc);
  },
  checkPreferences: function checkPreferences(prefs) {
    Common.checkPreferences(prefs);
  },
  compile: function compile(schema, options) {
    return Compile.compile(this, schema, options);
  },
  defaults: function defaults(modifier) {
    Assert(typeof modifier === 'function', 'modifier must be a function');
    var joi = Object.assign({}, this);
    var _iterator2 = _createForOfIteratorHelper(joi._types),
      _step2;
    try {
      var _loop3 = function _loop3() {
        var type = _step2.value;
        var schema = modifier(joi[type]());
        Assert(Common.isSchema(schema), 'modifier must return a valid schema object');
        joi[type] = function () {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          return internals.generate(this, schema, args);
        };
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return joi;
  },
  expression: function expression() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    return _construct(Template, args);
  },
  extend: function extend() {
    var _this = this;
    for (var _len6 = arguments.length, extensions = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      extensions[_key6] = arguments[_key6];
    }
    Common.verifyFlat(extensions, 'extend');
    Schemas = Schemas || require('./schemas');
    Assert(extensions.length, 'You need to provide at least one extension');
    this.assert(extensions, Schemas.extensions);
    var joi = Object.assign({}, this);
    joi._types = new Set(joi._types);
    for (var _i2 = 0, _extensions = extensions; _i2 < _extensions.length; _i2++) {
      var extension = _extensions[_i2];
      if (typeof extension === 'function') {
        extension = extension(joi);
      }
      this.assert(extension, Schemas.extension);
      var expanded = internals.expandExtension(extension, joi);
      var _iterator3 = _createForOfIteratorHelper(expanded),
        _step3;
      try {
        var _loop4 = function _loop4() {
          var item = _step3.value;
          Assert(joi[item.type] === undefined || joi._types.has(item.type), 'Cannot override name', item.type);
          var base = item.base || _this.any();
          var schema = Extend.type(base, item);
          joi._types.add(item.type);
          joi[item.type] = function () {
            for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
              args[_key7] = arguments[_key7];
            }
            return internals.generate(this, schema, args);
          };
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop4();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return joi;
  },
  isError: Errors.ValidationError.isError,
  isExpression: Template.isTemplate,
  isRef: Ref.isRef,
  isSchema: Common.isSchema,
  in: function _in() {
    return Ref.in.apply(Ref, arguments);
  },
  override: Common.symbols.override,
  ref: function ref() {
    return Ref.create.apply(Ref, arguments);
  },
  types: function types() {
    var types = {};
    var _iterator4 = _createForOfIteratorHelper(this._types),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var type = _step4.value;
        types[type] = this[type]();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    for (var target in internals.aliases) {
      types[target] = this[target]();
    }
    return types;
  }
};

// Helpers

internals.assert = function (value, schema, annotate, args /* [message], [options] */) {
  var message = args[0] instanceof Error || typeof args[0] === 'string' ? args[0] : null;
  var options = message ? args[1] : args[0];
  var result = schema.validate(value, Common.preferences({
    errors: {
      stack: true
    }
  }, options || {}));
  var error = result.error;
  if (!error) {
    return result.value;
  }
  if (message instanceof Error) {
    throw message;
  }
  var display = annotate && typeof error.annotate === 'function' ? error.annotate() : error.message;
  if (error instanceof Errors.ValidationError === false) {
    error = Clone(error);
  }
  error.message = message ? "".concat(message, " ").concat(display) : display;
  throw error;
};
internals.generate = function (root, schema, args) {
  var _schema$_definition;
  Assert(root, 'Must be invoked on a Joi instance.');
  schema.$_root = root;
  if (!schema._definition.args || !args.length) {
    return schema;
  }
  return (_schema$_definition = schema._definition).args.apply(_schema$_definition, [schema].concat(_toConsumableArray(args)));
};
internals.expandExtension = function (extension, joi) {
  if (typeof extension.type === 'string') {
    return [extension];
  }
  var extended = [];
  var _iterator5 = _createForOfIteratorHelper(joi._types),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var type = _step5.value;
      if (extension.type.test(type)) {
        var item = Object.assign({}, extension);
        item.type = type;
        item.base = joi[type]();
        extended.push(item);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return extended;
};
module.exports = internals.root();